export default __webpack_public_path__ + "static/media/frontpage.1c95b511.txt";